import React, {Component} from 'react'; 
import moment from 'moment'; 
import styled from 'styled-components'; 

const DiagonalCardContainer = styled.div`
  position: relative;
  float: left;
  overflow: hidden;
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
  max-width: ${props => `${props.containerWidth}px`}; 
  min-height: ${props => `${props.containerHeight}px`}; 
  width: 100%;
  color: #ffffff;
  text-align: left;
  line-height: 1.4em;
  background-color: ${props=> props.primaryColor};
  &:*{
    box-sizing: border-box;
    transition: all 0.25s ease;
  }
`
const WrapperCard = styled.div`
  background-color: ${props=> props.primaryColor};
  padding: 0 25px 25px;
  position: relative;
  &:before{
    position: absolute;
    content: '';
    bottom: 100%;
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 55px 0 0 400px;
    border-color: transparent transparent transparent ${props=> props.primaryColor};
  }
`
const ArticleDate = styled.div`
  position: absolute;
  font-family: "Oswald"; 
  background-color: ${props=> props.primaryColor}; 
  top: 0;
  right: 0;
  width: 100%;
  padding: 10px 25px 0;
  text-align: right;
  font-size: 0.8em;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  &:before{
    position: absolute;
    content: '';
    top: 100%;
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 400px 55px 0;
    border-color: transparent ${props=> props.primaryColor} transparent transparent;
  }
`
const Image = styled.img`
  width: 100%;
  max-width: 100%;
  vertical-align: top;
  opacity: 0.9;
`
const Title = styled.h3`
  margin: 0 0 10px;
  font-weight: 300; 
  text-align: center;
  line-height: 1.2em;
  font-family: "Oswald";
`
const Summary = styled.p`
  padding-top: 10px; 
  text-align: justify; 
  margin: 0 0 0px;
  font-family: "Open Sans";
  font-size: 14px;
  opacity: 0.85;
`

export class NewsDiagonalCard extends Component {

    render()
    {
        const { news, newsNumber, primaryColor, containerHeight, containerWidth } = this.props 
        if (news.length === 0) return null
        
        return (
            news.items.slice(0,newsNumber).map((article, i) =>  
            <DiagonalCardContainer primaryColor={primaryColor} containerHeight={containerHeight} containerWidth={containerWidth} key={i}>
                <Image src={article.image.split("|")[0]} alt="" />
                <ArticleDate primaryColor={primaryColor}>{moment(article.created).locale("fr").fromNow()}</ArticleDate>
                <WrapperCard primaryColor={primaryColor}>
                    <Title>{article.title}</Title>
                    <Summary> {article.description.split("...")[0]}...   </Summary>
                </WrapperCard>
            </DiagonalCardContainer>
        ))
    }

}



// WEBPACK FOOTER //
// ./src/components/News/NewsDiagonalCard/index.js